<h1 mat-dialog-title>{{ data?.titleLabel | translate }}</h1>
<div mat-dialog-content>
  <div class="column-drag-main-content">
    <div class="column-drag-container">
      <div class="column-drag-info-area">{{ data?.infoTextLabel | translate }}</div>
      <div class="column-drag-container-header">{{ data?.selectedLabel | translate }}</div>
      <div
        cdkDropList
        #selectedList="cdkDropList"
        [cdkDropListData]="selectedColumns"
        [cdkDropListConnectedTo]="[availableList]"
        class="column-drag-list selected-drag-list"
        (cdkDropListDropped)="onDrop($event)"
      >
        @for (selectedColumn of selectedColumns; track selectedColumn; let i = $index) {
          <div class="column-drag-box" cdkDrag [id]="selectedColumn.id">{{ i + 1 }}. {{ selectedColumn.label | translate }}</div>
        }
      </div>
    </div>

    <div class="column-drag-container">
      <div class="column-drag-info-area">
        <!-- Table filter -->
        <mat-form-field>
          <mat-label>{{ data?.filterColumnsLabel | translate }}</mat-label>
          <input
            matInput
            autocomplete="off"
            (keyup)="updateFilterValue()"
            placeholder="{{ data?.filterColumnsPlaceHolder | translate }}"
            [(ngModel)]="searchFilter"
          />
          @if (searchFilter) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilterValue()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <div class="column-drag-container-header">{{ data?.availableLabel | translate }}</div>
      <div
        cdkDropList
        cdkDropListSortingDisabled
        #availableList="cdkDropList"
        [cdkDropListData]="availableColumns"
        [cdkDropListConnectedTo]="[selectedList]"
        class="column-drag-list"
        (cdkDropListDropped)="onDrop($event)"
      >
        @for (availableColumn of filteredAvailableColumns; track availableColumn) {
          <div class="column-drag-box" cdkDrag [id]="availableColumn.id">
            {{ availableColumn.label }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <mad-outline-button (click)="onCancel()">
    {{ data?.cancelLabel | translate }}
  </mad-outline-button>
  @if (data?.deleteDefinitionAllowed) {
    <mad-danger-button (click)="onDelete()">
      {{ data?.deleteLabel | translate }}
    </mad-danger-button>
  }
  <mad-primary-button (click)="onSave()" [disabled]="!(this.selectedColumns?.length > 0)">
    {{ data?.saveLabel | translate }}
  </mad-primary-button>
</div>
